export default __webpack_public_path__ + "static/media/solen-feyissa-jGmBZypoFPc-unsplash.0fd20eca.jpg";